export default function PHP_RegEx() {
  return (
    <div>
      <h1>PHP_RegEx</h1>
    </div>
  );
}
